import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      light: "#808080",
      main: "#616161",
      dark: "#434343",
      contrastText: "#fff"

    },
    secondary: {
      light: "#349fda",
      main: "#0288d1",
      dark: "#015f92",
      contrastText: "#000"
    }
  }
});
